import React, { ReactNode } from 'react';
import styles from './GlassButton.module.css';

interface GlassButtonProps {
  href?: string;
  onClick?: () => void;
  children: ReactNode;
  target?: string;
  rel?: string;
  className?: string;
  buttonType?: 'primary' | 'secondary';
}

export const GlassButton: React.FC<GlassButtonProps> = ({
  href,
  onClick,
  children,
  target = "_blank",
  rel = "noopener noreferrer",
  className = "",
  buttonType = "primary",
}) => {
  const buttonClass = `${styles.glassButton} ${styles[buttonType]} ${className}`;

  if (href) {
    return (
      <a 
        href={href} 
        target={target} 
        rel={rel}
        className={buttonClass}
        onClick={onClick}
      >
        {children}
      </a>
    );
  }

  return (
    <button 
      className={buttonClass}
      onClick={onClick}
      type="button"
    >
      {children}
    </button>
  );
}; 